import React, { useEffect } from 'react';

export interface NextScriptProps extends React.ScriptHTMLAttributes<HTMLScriptElement> {
  strategy?: 'afterInteractive' | 'beforeInteractive' | 'lazyOnload' | 'worker';
  onLoad?: () => void;
  onError?: (e: any) => void;
}

export function Script({ src, onLoad, onError, ...rest }: NextScriptProps) {
  useEffect(() => {
    if (!src) return;

    // Check if script already exists
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (onLoad) onLoad();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    if (onLoad) script.onload = onLoad;
    if (onError) script.onerror = onError;
    document.body.appendChild(script);

    return () => {
      // Keep script in document or remove if needed
    };
  }, [src, onLoad, onError]);

  return null;
}

export default Script;
